import React from "react";
import { useParams, Link } from "react-router-dom";
import Section from "../components/Section";
import articlesData from "../data/articles.json";

const dateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric"
});

export default function ArticleDetail() {
  const { id } = useParams<{ id: string }>();
  const article = articlesData.articles.find((entry: any) => entry.id === id);

  if (!article) {
    return (
      <main className="min-h-screen">
        <Section title="Article not found" containerClassName="max-w-3xl">
          <p className="text-text-subtle">
            That write-up doesn&apos;t exist (yet). Check the archive and keep exploring.
          </p>
          <Link to="/articles" className="inline-flex mt-6 text-accent hover:text-primary transition">
            ← Back to Articles
          </Link>
        </Section>
      </main>
    );
  }

  const publishedDate = article.date ? dateFormatter.format(new Date(article.date)) : null;
  const content = article.content || article.summary || "";
  const paragraphs = content ? content.split("\n\n") : [];

  return (
    <main className="min-h-screen">
      <Section containerClassName="max-w-3xl">
        <Link
          to="/articles"
          className="font-mono text-xs text-text-subtle hover:text-primary mb-6 inline-flex items-center gap-2"
        >
          ← Back to Articles
        </Link>

        <article className="space-y-6">
          <header className="space-y-3">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-text-subtle">Field note</p>
            <h1 className="text-3xl font-mono text-primary">{article.title}</h1>
            <div className="flex flex-wrap gap-4 text-sm text-text-muted">
              {publishedDate && <span>{publishedDate}</span>}
              {article.readTime && (
                <span className="font-mono text-xs tracking-wide uppercase text-text-subtle">
                  {article.readTime}
                </span>
              )}
            </div>

            <div className="flex flex-wrap gap-2">
              {(article.tags || []).map((tag: string) => (
                <span
                  key={tag}
                  className="text-[11px] font-mono uppercase tracking-wide px-3 py-1 border border-border-subtle rounded-pill"
                >
                  {tag}
                </span>
              ))}
            </div>
          </header>

          <div className="space-y-4 text-sm sm:text-base text-text-muted leading-relaxed">
            {paragraphs.length > 0 ? (
              paragraphs.map((paragraph: string, index: number) => (
                <p key={index}>{paragraph}</p>
              ))
            ) : (
              <p>{article.summary}</p>
            )}
          </div>
        </article>
      </Section>
    </main>
  );
}

